<script lang="ts">
	export let width: number | 'string' = 246;
	export let height: number | 'string' = 246;
	export let fadeIn = false;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	{width}
	{height}
	viewBox="0 0 246 246"
	fill="none"
	class={fadeIn ? 'containerSvg' : ''}
>
	<g clip-path="url(#clip0_528_613)">
		<!-- <path
			d="M325.149 152.552C302.678 152.552 296.941 128.938 275.255 128.938C253.57 128.938 247.047 152.487 225.362 152.552C203.542 152.617 196.906 128.807 175.087 128.938C153.535 129.068 146.903 152.552 125.574 152.552C103.103 152.552 97.3665 128.938 75.6808 128.938C53.9952 128.938 47.4728 152.487 25.7872 152.552C3.96792 152.617 -2.66824 128.807 -24.4873 128.938C-46.039 129.068 -52.6714 152.552 -74 152.552"
			stroke="black"
			stroke-width="12"
			class="wave"
		/> -->
		<path
			d="M325.149 185.243C302.678 185.243 296.941 161.629 275.255 161.629C253.57 161.629 247.047 185.178 225.362 185.243C203.542 185.309 196.906 161.498 175.087 161.629C153.535 161.759 146.903 185.243 125.574 185.243C103.103 185.243 97.3665 161.629 75.6808 161.629C53.9952 161.629 47.4728 185.178 25.7872 185.243C3.96792 185.309 -2.66824 161.498 -24.4873 161.629C-46.039 161.759 -52.6714 185.243 -74 185.243"
			stroke="black"
			stroke-width="12"
			class="wave"
		/>
		<path
			d="M325.149 219.741C302.678 219.741 296.941 196.127 275.255 196.127C253.57 196.127 247.047 219.676 225.362 219.741C203.542 219.807 196.906 195.996 175.087 196.127C153.535 196.257 146.903 219.741 125.574 219.741C103.103 219.741 97.3665 196.127 75.6808 196.127C53.9952 196.127 47.4728 219.676 25.7872 219.741C3.96792 219.807 -2.66824 195.996 -24.4873 196.127C-46.039 196.257 -52.6714 219.741 -74 219.741"
			stroke="black"
			stroke-width="12"
			class="wave"
		/>
		<!-- <path
			d="M325.149 219.741C302.678 219.741 296.941 196.127 275.255 196.127C253.57 196.127 247.047 219.676 225.362 219.741C203.542 219.807 196.906 195.996 175.087 196.127C153.535 196.257 146.903 219.741 125.574 219.741C103.103 219.741 97.3665 196.127 75.6808 196.127C53.9952 196.127 47.4728 219.676 25.7872 219.741C3.96792 219.807 -2.66824 195.996 -24.4873 196.127C-46.039 196.257 -52.6714 219.741 -74 219.741"
			stroke="black"
			stroke-width="12"
			class="wave"
		/> -->
		<g transform="translate(0, 35)">
			<path
				d="M325.149 219.741C302.678 219.741 296.941 196.127 275.255 196.127C253.57 196.127 247.047 219.676 225.362 219.741C203.542 219.807 196.906 195.996 175.087 196.127C153.535 196.257 146.903 219.741 125.574 219.741C103.103 219.741 97.3665 196.127 75.6808 196.127C53.9952 196.127 47.4728 219.676 25.7872 219.741C3.96792 219.807 -2.66824 195.996 -24.4873 196.127C-46.039 196.257 -52.6714 219.741 -74 219.741"
				stroke="black"
				stroke-width="12"
				class="wave"
			/>
		</g>
		<path
			fill-rule="evenodd"
			class="star"
			clip-rule="evenodd"
			d="M124.176 34.2281C124.388 33.2318 125.812 33.236 126.019 34.2335L130.072 53.7807C131.409 60.2306 136.493 65.2442 142.96 66.4921L161.684 70.1047C162.695 70.2998 162.705 71.7434 161.696 71.9514L142.733 75.862C136.383 77.1716 131.41 82.1161 130.065 88.4587L125.954 107.832C125.743 108.826 124.325 108.827 124.112 107.833L119.961 88.4427C118.605 82.1086 113.631 77.1761 107.286 75.8727L88.3938 71.9923C87.3858 71.7852 87.3931 70.3426 88.4032 70.1458L107.141 66.4945C113.562 65.2434 118.615 60.2795 119.981 53.8822L124.176 34.2281Z"
			fill="black"
		/>
	</g>
	<rect
		x="6"
		y="6.10742"
		width="233.785"
		height="233.785"
		rx="116.893"
		stroke="black"
		stroke-width="12"
		class="circle"
	/>
	<defs>
		<clipPath id="clip0_528_613">
			<rect y="0.107422" width="245.785" height="245.785" rx="122.893" fill="white" />
		</clipPath>
	</defs>
</svg>

<style>
	.star {
		transform-origin: center;
		animation: 2s scale-down-center infinite;
	}

	.wave {
		transform-origin: center;
		animation: 4s wavy infinite;
	}

	.containerSvg {
		animation: 1s fadeIn ease-out;
	}

	@keyframes scale-down-center {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes wavy {
		0% {
			transform: translate(0, 20%);
		}
		50% {
			transform: translate(5%, -2%);
		}
		100% {
			transform: translate(0, 20%);
		}
	}
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		20% {
			opacity: 0;
		}
		40% {
			opacity: 1;
		}
		100% {
			opacity: 1;
		}
	}
</style>
